import { useTreeItem, TreeItemContentProps } from '@mui/lab/TreeItem';
import clsx from 'clsx';
import React from 'react';
export const CustomContent = React.forwardRef(function CustomContent(
  props: TreeItemContentProps,
  ref
) {
  const { classes, className, label, nodeId, icon: iconProp, expansionIcon, displayIcon } = props;

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem(nodeId);

  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    preventSelection(event);

  const handleExpansionClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    handleExpansion(event);

  const handleSelectionClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    handleSelection(event);

  return (
    <div
      role={'button'}
      tabIndex={0}
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref as React.Ref<HTMLDivElement>}
    >
      <div
        role={'button'}
        tabIndex={0}
        onClick={handleExpansionClick}
        className={classes.iconContainer}
        onKeyPress={() => null}
      >
        {icon}
      </div>
      <div
        role={'button'}
        tabIndex={0}
        onClick={handleSelectionClick}
        className={classes.label}
        onKeyPress={() => null}
      >
        {label}
      </div>
    </div>
  );
});
